import appConfig from './apiConfig';

export const fetchPaymentUsersApi =(token)=>{
  
    const headers = Object.assign({'content-type':'application/json',
                                   'accept':'*/*'
                               });
    const request= new Request( appConfig.siteURL+'collectAllPaymentTransaction/'+ token, {
      method : "GET",
      headers : headers,
    });
    
    return fetch(request).then(response => {
        return  response.json().then(paymentUsersDataResponse => {
          return paymentUsersDataResponse;
        });
      }).catch(error => {
       return error;
     });
    }


//fetchpaymentDataByUserIDApi

export const fetchpaymentDataByUserIDApi =(tId, token)=>{
  
  const headers = Object.assign({'content-type':'application/json',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'collectPaymentTransactionByUser/'+ token+"/"+ tId, {
    method : "GET",
    headers : headers,
  });
  
return fetch(request).then(response => {
    return  response.json().then(paymentUsersDataResponse => {
      return paymentUsersDataResponse;
    });
  }).catch(error => {
    return error;
  });
}

//verifyPaypalTranactionApi

export const verifyPaypalTranactionApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'verifyPaypalTranaction', {
    method : "POST",
    headers : headers,
    body : objData
  });
  
  return fetch(request).then(response => {
      return  response.json().then(paymentUsersDataResponse => {
        return paymentUsersDataResponse;
      });
    }).catch(error => {
      return error;
    });
  }

//rejectPaypalTransactionApi
export const rejectPaypalTransactionApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'rejectPaypalTransaction', {
    method : "POST",
    headers : headers,
    body : objData
  });
  
  return fetch(request).then(response => {
      return  response.json().then(paymentUsersDataResponse => {
        return paymentUsersDataResponse;
      });
    }).catch(error => {
      return error;
    });
  }

//paypalPaymentPayToUserApi
export const paypalPaymentPayToUserApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'payWithPaypal', {
    method : "POST",
    headers : headers,
    body : objData
  });
  
  return fetch(request).then(response => {
      return  response.json().then(paymentUsersDataResponse => {
        return paymentUsersDataResponse;
      });
    }).catch(error => {
      return error;
    });
  }

  //checkPaypalPaymentApi
  export const checkPaypalPaymentApi =(data)=>{
    let objData =  JSON.stringify(data);
    const headers = Object.assign({'content-type':'application/json',
                                    'accept':'*/*'
                                });
    const request= new Request( appConfig.siteURL+'checkpayWithPaypal', {
      method : "POST",
      headers : headers,
      body : objData
    });
    
    return fetch(request).then(response => {
        return  response.json().then(paymentUsersDataResponse => {
          return paymentUsersDataResponse;
        });
      }).catch(error => {
        return error;
      });
    }

//getCouponsToAsigntoUserByAdminApi
export const getCouponsToAsigntoUserByAdminApi =(token)=>{
  
  const headers = Object.assign({'content-type':'application/json',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'getAllCouponCountByAdmin/'+ token, {
    method : "GET",
    headers : headers,
  });
  
return fetch(request).then(response => {
    return  response.json().then(couponCountDataResponse => {
      return couponCountDataResponse;
    });
  }).catch(error => {
    return error;
  });
}

//giftCouponOnlinePaymentPayUserApi
export const giftCouponOnlinePaymentPayUserApi =(data)=>{
  let objData =  JSON.stringify(data);
  const headers = Object.assign({'content-type':'application/json',
                                  'accept':'*/*'
                              });
  const request= new Request( appConfig.siteURL+'assignGiftcouponOnline', {
    method : "POST",
    headers : headers,
    body : objData
  });
  
  return fetch(request).then(response => {
      return  response.json().then(giftCouponPaymentUsersDataResponse => {
        return giftCouponPaymentUsersDataResponse;
      });
    }).catch(error => {
      return error;
    });
  }


// WEBPACK FOOTER //
// ./src/api/paymentApi.js